import { Col, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";

import { DatePicker, Input, Select } from "components/form";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import styles from "../styles/RequestApprovalFilter.module.css";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const WarningletterFilter = ({
    initialValues = {},
    dataFlag = " ",
    onSubmit = () => { },
    leaveGroupOptions = [],
    employeeOptions = [],
    penaltiesOptions = [],
    companyRegulationOptions = [],

}) => {
    const { t } = useTranslation();
    const { modifiedStatus = [] } = useStatusFlagOption();
    console.log('menu', dataFlag);
    function formatDate(dateString, pattern = "DD-MM-YYYY") {
        // console.log("dateString", dateString);
        if (!dateString) return;
        const date = dayjs(dateString, pattern);
        return date.format("DD-MM-YYYY");
    }
    const shiftTypeOptions = [
        {
            value: "SWAP",
            label: t('changeshift.swap')
        },
        {
            value: "CHANGESHIFT",
            label: t('changeshift.label.changeshift')
        }
    ]
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                onSubmit({
                    ...values,
                });
            }}
        >
            {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
                return (
                    <Form>

                        <Row gutter={[24, 16]} className={styles.filter} >
                            <Col span={12}>
                                <Select
                                    name="employeeId"
                                    label={t('name-surname')}
                                    placeholder={t('common.pleaseSelect')}
                                    size="large"
                                    options={employeeOptions}
                                />
                            </Col>
                            <Col span={12}>
                                <DatePicker
                                    name="incidentDate"
                                    label={t('warning_letter.label.date_of_incident')}
                                    placeholder={t('common.placeholder.ddmmyyyy')}
                                    size="large"
                                    format={formatDate()}
                                />
                            </Col>
                            <Col span={12}>
                                <Select
                                    name="companyRegulationId"
                                    label={t('warning_letter.label.company_regulation')}
                                    placeholder={t('common.pleaseSelect')}
                                    size="large"
                                    options={companyRegulationOptions}
                                />
                            </Col>
                            <Col span={12}>
                                <Select
                                    name="penaltyTypeId"
                                    label={t('warning_letter.label.penalty')}
                                    placeholder={t('common.pleaseSelect')}
                                    size="large"
                                    options={penaltiesOptions}
                                // onChange={(options) => {
                                //     setPenaltyType(options)
                                // }}
                                />
                            </Col>
                            <Col span={12}>
                                <Select
                                    name="statusFlag"
                                    label={t('translation.status')}
                                    placeholder={t('translation.status')}
                                    size="large"
                                    options={modifiedStatus}
                                />
                            </Col>
                        </Row>

                        <Row justify="end">
                            <Space size={12} className={styles.filterbtn}>
                                <Button type="default" onClick={resetForm}
                                    style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                                >
                                    {t("cancel-1").toUpperCase()}
                                </Button>
                                <Button type="primary" htmlType="submit"
                                    style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                                >
                                    {t("creatTamplete.Search").toUpperCase()}
                                </Button>
                            </Space>
                        </Row>
                    </Form>
                );
            }}

        </Formik>
    )
};

export default WarningletterFilter;
